import { render, staticRenderFns } from "./Reclamaciones.vue?vue&type=template&id=2956b78e&scoped=true&"
import script from "./Reclamaciones.vue?vue&type=script&lang=js&"
export * from "./Reclamaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956b78e",
  null
  
)

export default component.exports